import { render, staticRenderFns } from "./EssayGradingModal.vue?vue&type=template&id=37b3456a"
import script from "./EssayGradingModal.vue?vue&type=script&lang=js"
export * from "./EssayGradingModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports